import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Fade } from "./Fade";

const plans = [
  {
    name: "Free",
    price: "$0",
    period: "forever",
    description: "Get started with core features",
    features: [
      "Basic dashboard analytics",
      "Up to 2 channel integrations",
      "Campaign management",
      "Marketing capital access",
      "Email support",
    ],
    cta: "Get plan",
    ctaLink: "/auth?tab=signup",
    highlight: false,
  },
  {
    name: "Pro",
    price: "$49",
    period: "/month",
    description: "Everything you need to scale",
    features: [
      "Growth Lever Advisor & insights",
      "Unlimited integrations",
      "Co-investment capital access",
      "Automated workflows",
      "Team collaboration & roles",
      "Priority support",
    ],
    cta: "Get plan",
    ctaLink: "/auth?tab=signup",
    highlight: true,
  },
  {
    name: "Enterprise",
    price: "Custom",
    period: "",
    description: "For agencies and large teams",
    features: [
      "Everything in Pro",
      "Custom integrations & API access",
      "Dedicated success manager",
      "SLA guarantees",
    ],
    cta: "Contact us",
    ctaLink: "/contact",
    highlight: false,
  },
];

export function PricingPreview() {
  return (
    <section id="pricing" className="px-5 sm:px-8 md:px-10 py-20 sm:py-28">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <Fade>
            <p className="text-xs tracking-[0.2em] uppercase text-[hsl(217_91%_60%)] mb-4 font-medium">
              Pricing
            </p>
          </Fade>
          <Fade delay={0.05}>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-[-0.02em] mb-4">
              Get started with Growth Lever
            </h2>
          </Fade>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {plans.map((plan, i) => (
            <Fade key={plan.name} delay={0.06 * i} y={16}>
              <div
                className={`relative rounded-lg border p-6 flex flex-col h-full ${
                  plan.highlight
                    ? "border-[hsl(217_91%_60%)]/40 bg-[hsl(217_91%_60%)]/[0.04]"
                    : "border-white/[0.08] bg-white/[0.02]"
                }`}
              >
                {plan.highlight && (
                  <span className="absolute -top-3 left-5 text-[11px] font-semibold tracking-wide uppercase bg-[hsl(217_91%_60%)] text-white px-3 py-0.5 rounded-full">
                    Popular
                  </span>
                )}

                <div className="mb-5">
                  <h3 className="text-base font-semibold mb-1">{plan.name}</h3>
                  <div className="flex items-baseline gap-1 mb-1">
                    <span className="text-3xl font-bold">{plan.price}</span>
                    <span className="text-sm text-white/35">{plan.period}</span>
                  </div>
                  <p className="text-sm text-white/40">{plan.description}</p>
                </div>

                <div className="flex-1 space-y-2.5 mb-6">
                  {plan.features.map((f) => (
                    <div key={f} className="flex items-start gap-2 text-sm">
                      <Check className="h-4 w-4 text-[hsl(142_71%_45%)] shrink-0 mt-0.5" />
                      <span className="text-white/70">{f}</span>
                    </div>
                  ))}
                </div>

                <Link
                  to={plan.ctaLink}
                  className={`flex items-center justify-center gap-2 text-sm font-semibold py-2.5 rounded-full transition-colors ${
                    plan.highlight
                      ? "bg-white text-black hover:bg-white/90"
                      : "border border-white/15 text-white/70 hover:text-white hover:border-white/30"
                  }`}
                >
                  {plan.cta} <ArrowRight className="h-3.5 w-3.5" />
                </Link>
              </div>
            </Fade>
          ))}
        </div>

        <Fade delay={0.25}>
          <div className="text-center mt-10">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 text-white font-semibold text-sm bg-[hsl(217_91%_60%)] px-7 py-3 rounded-full hover:bg-[hsl(217_91%_65%)] transition-colors"
            >
              Get a Demo <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </Fade>
      </div>
    </section>
  );
}
